import { useCallback } from 'react'

import { ProductV2, StoreOfferProduct } from '@common'

import { scrollModal } from '@/components/Modal'

import { useModalContext } from '../../../../contexts/ModalContext'

type UseHandleClickProps = {
  product: StoreOfferProduct | ProductV2
  pathname: string
}

export const useHandleClick = ({ product, pathname }: UseHandleClickProps) => {
  const { openModal } = useModalContext()
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      // Resort to default behavior if user is holding down the ctrl or meta key
      if (event.ctrlKey || event.metaKey) {
        return
      }
      // Prevent opening the product page on background when user clicks the card
      event.preventDefault()

      openModal({ type: 'PRODUCT', props: { product } })
      // Scroll modal to top
      scrollModal(0, 0)
    },
    [product, openModal, pathname],
  )
  return { handleClick }
}
